import React, {useState, useEffect} from 'react';
import cx from 'classnames';
import {encode} from 'shopify-gid';
import {Collapse} from '@mui/material';
import {
	useAddItemsToCart,
	useRemoveItemFromCart,
	useCartItems,
} from 'src/context/storeContext';

import {
	useCartAttributes,
	useUpdateCheckoutAttributes,
} from 'src/context/storeContext';

import * as styles from './order-options.module.css';

export const OrderOptions = () => {
	const cartItems = useCartItems();
	const cartAttributes = useCartAttributes();
	const addItemsToCart = useAddItemsToCart();
	const removeFromCart = useRemoveItemFromCart();
	const updateCheckoutAttributes = useUpdateCheckoutAttributes();

	const [giftOptionsOpen, setGiftOptionsOpen] = useState(false);

	const [isGift, setIsGift] = useState(
		cartAttributes &&
			cartAttributes.length > 0 &&
			cartAttributes.find(attribute => attribute.key === 'Gift Receipt')
				.value === 'true'
			? true
			: false,
	);

	const [giftWrap, setGiftWrap] = useState(
		cartAttributes &&
			cartAttributes.length > 0 &&
			cartAttributes.includes(
				attribute => attribute.key === 'Gift Wrap',
			) &&
			cartAttributes.find(attribute => attribute.key === 'Gift Wrap')
				.value === 'true'
			? true
			: false,
	);

	const [giftWrapChecked, setGiftWrapChecked] = useState(giftWrap);

	const [giftNote, setGiftNote] = useState(
		(cartAttributes &&
			cartAttributes.length > 0 &&
			cartAttributes.includes(
				attribute => attribute.key === 'Gift Note',
			) &&
			cartAttributes.find(attribute => attribute.key === 'Gift Note')
				.value) ||
			'',
	);

	const [minimalPackaging, setMinimalPackaging] = useState(
		cartAttributes &&
			cartAttributes.length > 0 &&
			cartAttributes.includes(
				attribute => attribute.key === 'Minimal Packaging',
			) &&
			cartAttributes.find(
				attribute => attribute.key === 'Minimal Packaging',
			).value === 'true'
			? true
			: false,
	);

	const [minimalPackagingChecked, setMinimalPackagingChecked] =
		useState(minimalPackaging);

	useEffect(() => {
		const giftWrapInCart = cartItems.some(
			item => item.title === 'Gift Wrapping',
		);
		setGiftWrap(giftWrapInCart);
		setGiftWrapChecked(giftWrapInCart);
	}, [cartItems]);

	const giftWrapEncodedVariantId = encode('ProductVariant', 8953561477, {
		accessToken: process.env.GATSBY_SHOPIFY_TOKEN,
	});

	const toggleGiftWrap = checked => {
		const giftWrapLineItem = cartItems.find(
			item => item.title === 'Gift Wrapping',
		);

		if (checked && !giftWrapLineItem) {
			setGiftWrapChecked(true);
			// setup items to add
			let itemsToAdd = [
				{
					variantId: giftWrapEncodedVariantId,
					quantity: 1,
				},
			];

			// add item to cart
			addItemsToCart(itemsToAdd).then(() => {
				setGiftWrap(true);
			});
		} else if (!checked && giftWrapLineItem) {
			setGiftWrapChecked(false);
			removeFromCart(giftWrapLineItem.id).then(() => {
				setGiftWrap(false);
			});
		} else {
			setGiftWrapChecked(false);
			setGiftWrap(false);
		}
	};

	const toggleMinimalPackaging = checked => {
		if (checked) {
			setMinimalPackagingChecked(true);
			setMinimalPackaging(true);
		} else if (!checked) {
			setMinimalPackagingChecked(false);
			setMinimalPackaging(false);
		}
	};

	useEffect(() => {
		updateCheckoutAttributes({
			customAttributes: [
				{
					key: 'Gift Receipt',
					value: `${isGift}`,
				},
				{
					key: 'Gift Wrap',
					value: `${isGift ? giftWrap : 'false'}`,
				},
				{
					key: 'Gift Note',
					value: `${isGift ? giftNote : ''}`,
				},
				{
					key: 'Minimal Packaging',
					value: `${minimalPackaging}`,
				},
			],
		});
	}, [isGift, giftWrap, giftNote, minimalPackaging]);

	return (
		<div className={styles.orderOptions}>
			<div className={styles.packagingOptions}>
				<div className={styles.fieldset}>
					<div>
						<label className={cx('checkbox', styles.checkbox)}>
							<input
								type="checkbox"
								checked={minimalPackagingChecked}
								onChange={e =>
									toggleMinimalPackaging(e.target.checked)
								}
							/>
							<span>
								Please ship my order with minimal packaging
							</span>
						</label>
					</div>
				</div>
			</div>
			<div className={styles.giftOptions}>
				<button
					className={cx('reset c-gold', styles.toggleButton)}
					onClick={() => setGiftOptionsOpen(!giftOptionsOpen)}>
					<h4 className="label-caps underline-on-hover">
						Is this a gift?
					</h4>
				</button>
				<Collapse in={giftOptionsOpen}>
					<div className={styles.fieldset}>
						<div className={styles.column}>
							<div className="my1">
								<label className="checkbox">
									<input
										type="checkbox"
										checked={isGift}
										onChange={e =>
											setIsGift(e.target.checked)
										}
									/>
									<span>Include gift receipt</span>
								</label>
							</div>
							<div className="my1">
								<label className={cx('checkbox')}>
									<input
										type="checkbox"
										checked={giftWrapChecked}
										onChange={e =>
											toggleGiftWrap(e.target.checked)
										}
									/>
									<span>Add gift wrapping ($10)</span>
								</label>
							</div>
						</div>
						<div className={cx(styles.column, 'my1')}>
							<label>
								<textarea
									value={giftNote}
									className="default c-gold x"
									placeholder="Enter gift message here..."
									onChange={e => setGiftNote(e.target.value)}
								/>
							</label>
						</div>
					</div>
				</Collapse>
			</div>
		</div>
	);
};
